"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numberToPercent = void 0;
var numeric_1 = require("../../../functions/numeric");
var round_to_int_1 = require("../../../functions/round-to-int");
var clamp100 = (0, numeric_1.clamp)(0, 100);
var numberToPercent = function (x) { return clamp100((0, round_to_int_1.roundToInt)(x)); };
exports.numberToPercent = numberToPercent;
